module.exports = __webpack_public_path__ + "img/entertainment-14.f6988e9b.jpg";